import React, { useState } from 'react';
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography
} from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Icon } from '@iconify/react';
import SettingsFunctionsGuard from '../../../../../guards/SettingsFunctionsGuard';
import { rolesConfPermissions } from '../../../../../constants/rolesConfPermissions';
import MethodSection from './MethodSection';
import { useSelector } from 'react-redux';

export default function DialogSettingMethodPay() {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <SettingsFunctionsGuard settingId={rolesConfPermissions.methodPaymentsSetting}>
      <IconButton variant="contained" color="info" onClick={() => setOpenDialog(true)}>
        <Icon icon="eva:settings-2-fill" />
      </IconButton>
      <DialogSettingBody open={openDialog} onClose={setOpenDialog} />
    </SettingsFunctionsGuard>
  );
}

function DialogSettingBody({ open, onClose }) {
  const settingID = rolesConfPermissions.methodPaymentsSetting;
  const { settingsList } = useSelector((state) => state.settingsFunc);
  const findedSet = settingsList.find((set) => set.id === settingID);
  const handleClose = () => {
    onClose(false);
  };

  // console.log('la conf----', findedSet);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle>
      <DialogContent>
        <Card sx={{ padding: '15px' }}>
          <Typography variant="subtitle1">Metodos de pago</Typography>
          <Divider />
          <Box marginTop="15px">
            {findedSet.methods.map((set) => (
              <MethodSection key={set.id} dataConf={set} generalActualSetting={findedSet} />
            ))}
          </Box>
        </Card>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', gap: '25px' }}>
        {/* <Button fullWidth variant="contained">
          Guardar
        </Button> */}

        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions>
    </Dialog>
  );
}
